import CrudTable from "../../../crud/CrudTable"
import {paymenttypesupplierService as service} from "../../../../services"

const initFilter =  {
    name : null,
    code: null,
};


export default function PaymentSupplier() {

  const createEstructureFilter =  [
     {
       type:"input",
       name: "name",
       col: 4
      },
  ];


  return (
    <CrudTable
          service={service}
          urledit={"/paymenttypesupplier/edit/"}
          urlnew={"/paymenttypesupplier/new/"}
          filter={initFilter}
          i18n={"paymentsupplier"}
          fieldstable={["id","name"]}
          estructureForm={createEstructureFilter} />
  );
}
